import React from "react";
/*eslint-disable */
import icon from "../../../assets/03_Producto/Webp/Group.webp";

interface ServiciosComponentProps {
  services: any;
}

declare const window: any;
const ServiciosComponent: React.FC<ServiciosComponentProps> = ({
  services,
}) => {
  console.log(services);

  return (
    <div className="servicios-posventa-servicios-container">
      {services?.map((item: any, index: number) => (
        <div
          key={index}
          className={`contenido-servicios-posventa-servicios-container ${
            item.format === "left" ? "anormal" : ""
          }`}
        >
          <div className="img-contenido-servicios-posventa-servicios-container">
            <img 
              src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} 
              alt={item?.title ? item.title : "Imagen del servicio"} 
            />
          </div>
          
          <div className="text-contenido-servicios-posventa-servicios-container">
            {/* H2/H3 según contexto - Título del servicio */}
            <h2 className="title">{item?.title}</h2>
            
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: item?.description }}
            ></div>
            
            {item.enable_button ? (
              // BOTÓN SIN MODIFICAR (igual que antes)
              <a href={item?.button_url} className="btn">
                Ver más
              </a>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiciosComponent;